module.exports = __webpack_public_path__ + "static/media/place.48146bc0.svg";